import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Popconfirm, Button } from 'antd';
import styles from './index.less';

interface ConfirmInterface {
  title: string,
  onConfirm: () => void,
  onCancel: () => void,
  okText: string,
  cancelText: string,
  dashboard: { title: string }
}

const Confirm = ({
  title,
  onConfirm,
  onCancel,
  okText,
  cancelText,
  dashboard,
}: ConfirmInterface) => (
  <Popconfirm
    title={title}
    onConfirm={onConfirm}
    onCancel={onCancel}
    okText={okText}
    cancelText={cancelText}
    placement="rightBottom"
  >
    <Button
      id={`tab-close-${dashboard.title}`.toLowerCase()}
      icon={<CloseOutlined />}
      size="small"
      className={styles.tabCloseBtn}
    />
  </Popconfirm>
);

export default React.memo(Confirm);
